<mat-toolbar>
  <app-country-selector></app-country-selector>
  <button mat-button>
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>
